'use strict';

var _ = require('lodash');
var PricingSummaryFareChangeTransformerFactory = function PricingSummaryFareChangeTransformerFactory(DataTransformer) {
  function PricingSummaryFareChangeTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'pricing-summary-fare-change';
    this.targetType = 'pricing-summary-fare-change';
  }
  PricingSummaryFareChangeTransformer.prototype = Object.create(DataTransformer.prototype);
  PricingSummaryFareChangeTransformer.constructor = PricingSummaryFareChangeTransformer;
  PricingSummaryFareChangeTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  PricingSummaryFareChangeTransformer.prototype.isCacheable = function () {
    return false;
  };
  PricingSummaryFareChangeTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function flattenedSummaries(summaryDetails) {
    return _.chain(summaryDetails).map(unwindPosCabins).flatten().map(unwindDtdData).flatten().value();
  }
  function unwindPosCabins(summaryDetail) {
    return _.map(summaryDetail.marketPosCabin, function (posCabin) {
      return {
        market: summaryDetail.market,
        runNumber: summaryDetail.runNumber,
        pos: posCabin.pos,
        cabin: posCabin.cabinCode,
        direction: posCabin.direction,
        daysToDeparture: posCabin.daysToDeparture
      };
    });
  }
  function unwindDtdData(posCabin) {
    return _.map(posCabin.daysToDeparture, function (dtdData) {
      return {
        market: posCabin.market,
        pos: posCabin.pos,
        cabin: posCabin.cabin,
        direction: posCabin.direction,
        runNumber: posCabin.runNumber,
        departureDateDay: parseInt(dtdData.days),
        metrics: {
          totalFareChange: dtdData.totalFareChange || 0,
          effServices: dtdData.effServices || 0,
          excludedServices: dtdData.excludedServices || 0
        }
      };
    });
  }
  PricingSummaryFareChangeTransformer.prototype.transform = function (summaryDetails) {
    var data = _.get(summaryDetails, 'domain.priceRecommendationSummaryDetails', []);
    return flattenedSummaries(data);
  };
  return PricingSummaryFareChangeTransformer;
};
PricingSummaryFareChangeTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = PricingSummaryFareChangeTransformerFactory;